import {Button, Toolbar, ToolbarItem} from "@progress/kendo-react-buttons"
import {DatePicker} from "@progress/kendo-react-dateinputs"
import {DropDownList} from "@progress/kendo-react-dropdowns"
import {Field, FieldRenderProps, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {
    MDBBtn,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
} from "mdbreact"
import React from "react"
import {useEffect, useRef, useState} from "react"
import {useLocation} from "react-router-dom"
import {
    BookingDetail,
    bookingInit,
    fetchBookingDetail,
    saveBookingDetails,
    toggleBreakDialog,
} from "../../containers/MotBooking/bookingSlice"
import {RootState} from "../../rootReducer"
import {SpinnerFragment} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"
import AlertToastr from "../Shared/alertToastr"
import TestTimePicker from "./controls/timePicker"

const BreakAddEditModal = () => {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const bookingId = useAppSelector((state: RootState) => state.containers.motBooking.selectedBookingId)
    const showBreakDialog = useAppSelector((state: RootState) => state.containers.motBooking.showBreakDialog)

    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)
    const bookingDetail = useAppSelector((state: RootState) => state.containers.motBooking.bookingDetail)
    const loadingBookingDetail = useAppSelector((state: RootState) => state.containers.motBooking.loadingBookingDetail)

    const savingBooking = useAppSelector((state: RootState) => state.containers.motBooking.savingBooking)
    // const successToastr = useAppSelector((state: RootState) => state.containers.motBooking.showsuccessToastr)
    // const errorToastr = useAppSelector((state: RootState) => state.containers.motBooking.showErrorToastr)
    // const errorMessage = useAppSelector((state: RootState) => state.containers.motBooking.errorMessage)

    const dayAvailabilityInterval = useAppSelector(
        (state: RootState) => state.containers.motBooking.dvsaDayAvailability,
    )

    const [booking, changeBookingState] = useState<BookingDetail>(bookingInit())

    const {dealerID, testStart, testEnd} = booking

    const formRef = useRef<any>()

    useEffect(() => {
        if (showBreakDialog && bookingId) {
            dispatch(fetchBookingDetail(bookingId))
        }
    }, [showBreakDialog, bookingId, dispatch])

    useEffect(() => {
        changeBookingState(bookingDetail)
    }, [bookingDetail])

    const breakFormSubmitHandler = React.useCallback(
        (e: any) => {
            const data = e as BookingDetail
            dispatch(saveBookingDetails(data, true, location.pathname))
        },
        [location.pathname],
    )

    const BKDealerDropdown = (fieldRenderProps: FieldRenderProps) => {
        const {onChange, label} = fieldRenderProps
        return (
            <>
                <DropDownList
                    value={userDealers.find(t => t.dealerId === dealerID)}
                    onChange={onChange}
                    textField="dealerName"
                    dataItemKey="dealerId"
                    data={userDealers}
                    label={label}
                    disabled
                />
            </>
        )
    }

    const BKDatePicker = (fieldRenderProps: FieldRenderProps) => {
        const {label, value} = fieldRenderProps
        return (
            <DatePicker
                name="testStart"
                value={value !== null ? new Date(value) : null}
                format="dd/MM/yyyy"
                label={label}
                disabled
            />
        )
    }

    const getMinEndTime = (testStartDate: Date) => {
        return dayAvailabilityInterval?.end && testStartDate < dayAvailabilityInterval?.end ? testStartDate : undefined
    }

    return (
        <>
            <AlertToastr />
            <MDBModal staticBackdrop animationDirection="right" show={showBreakDialog} tabIndex="-1">
                <MDBModalDialog position="top right moddal" side>
                    <MDBModalContent className="full-height ">
                        <MDBModalHeader>
                            <MDBModalTitle>{booking.bookingID > 0 ? booking.bookingRef : ""}</MDBModalTitle>
                            <MDBBtn
                                color="none"
                                className="btn-close"
                                onClick={() => {
                                    dispatch(toggleBreakDialog(false))
                                }}
                            ></MDBBtn>
                        </MDBModalHeader>
                        {(loadingBookingDetail || savingBooking) && <SpinnerFragment />}
                        {showBreakDialog && !loadingBookingDetail && booking.bookingTypeID === 2 && (
                            <Form
                                key={JSON.stringify(booking)}
                                initialValues={booking}
                                onSubmit={breakFormSubmitHandler}
                                ref={formRef}
                                ignoreModified
                                render={(formRenderProps: FormRenderProps) => (
                                    <FormElement className="w-100">
                                        <Toolbar className="shadow-0 border-bottom p-0 pb-1 pt-1 ps-1 position-sticky top-0">
                                            <ToolbarItem>
                                                <Button
                                                    disabled={!formRenderProps.valid}
                                                    type="submit"
                                                    fillMode="flat"
                                                    themeColor={"primary"}
                                                    iconClass="fa fa-save"
                                                >
                                                    Save
                                                </Button>
                                            </ToolbarItem>
                                        </Toolbar>
                                        <MDBModalBody className="modal-overflow">
                                            <fieldset className={"k-form-fieldset mt-0"}>
                                                <MDBRow>
                                                    <MDBCol md="12">
                                                        <div>Break Details</div>
                                                        <hr className="title-hr mt-0" />
                                                        <Field
                                                            name={"dealerID"}
                                                            component={BKDealerDropdown}
                                                            label={"Dealer"}
                                                        />
                                                        <Field
                                                            name={"testStart"}
                                                            component={BKDatePicker}
                                                            value={bookingDetail.testStart}
                                                            label={"Date"}
                                                        />
                                                    </MDBCol>
                                                    <MDBRow>
                                                        <MDBCol md="6">
                                                            <Field
                                                                name={"testStart"}
                                                                component={TestTimePicker}
                                                                value={new Date(testStart)}
                                                                label={"Start"}
                                                                min={dayAvailabilityInterval?.start ?? undefined}
                                                                max={dayAvailabilityInterval?.end ?? undefined}
                                                                updateStateValue={(value: string) => {
                                                                    const bkdt = {...booking, testStart: value}
                                                                    changeBookingState(bkdt)
                                                                }}
                                                            />
                                                        </MDBCol>
                                                        <MDBCol md="6">
                                                            <Field
                                                                name={"testEnd"}
                                                                component={TestTimePicker}
                                                                value={new Date(testEnd)}
                                                                label={"End"}
                                                                min={getMinEndTime(new Date(booking.testStart))}
                                                                max={dayAvailabilityInterval?.end ?? undefined}
                                                                updateStateValue={(value: string) => {
                                                                    const bkdt = {...booking, testEnd: value}
                                                                    changeBookingState(bkdt)
                                                                }}
                                                            />
                                                        </MDBCol>
                                                    </MDBRow>
                                                </MDBRow>
                                            </fieldset>
                                        </MDBModalBody>
                                    </FormElement>
                                )}
                            />
                        )}
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}

export default BreakAddEditModal
